<template>
  <div class="list-group list-group-flush">

    <div class="h5 fw-semibold mb-0 px-3 pt-2">{{ listing.listingTitle }}</div>

    <!-- Loading Listing Info -->
    <div v-if="listing.fetchingDetails" class="px-3 d-flex flex-rw align-items-center">
      <SpinnerView class="me-2" small /> Loading listing details
    </div>

    <!-- Host -->
    <div v-if="listing.listingHost" class="px-3 py-1">
      Hosted by {{ listing.listingHost }}
    </div>

    <!-- Source URL -->
    <div v-if="listing.url" class="px-3 small">
      <a :href="safeHref(listing.url)" target="source-listing" class="text-muted" rel="noopener noreferrer">
        <ListingSourceIcon :listing="listing" class="me-1"/>
        {{ listing.url.replace(/^https?:\/\//, '').replace(/\?.*/, '') }}
      </a>
    </div>

    <!-- Images -->
    <div v-if="listing.images.length > 0" class="list-group-item border-0">
      <ImageGallery :image-urls="listing.images" v-model:primary-image="primaryImage" />
    </div>

    <!-- Description -->
    <div v-if="listingDescription.length > 0" class="px-3 mb-3">
      <div v-for="(line, index) in listingDescription" :key="index" :class="`mt-3 ${line.bold ? 'fw-bold' : ''}`">
        {{ line.text }}
      </div>
    </div>
  </div>
</template>

<script>
import { safeHref } from '@/safeRendering';
import {Listing} from "@/models/Listing";
import ListingSourceIcon from "@/components/common/ListingSourceIcon.vue";
import SpinnerView from "@/components/common/SpinnerView.vue";
import ImageGallery from "@/components/common/ImageGallery.vue";

export default {
  methods: {
    safeHref
  },
  components: {ImageGallery, SpinnerView, ListingSourceIcon},
  props: {
    listing: Listing
  },
  computed: {
    primaryImage: {
      get() {
        return this.listing.primaryImage || this.listing.images[0];
      },
      set(image) {
        this.listing.updatePrimaryImageIndex(this.listing.images.indexOf(image));
      }
    },
    listingDescription() {
      let d = this.listing.listingDescription;
      if (!d) {
        return [];
      }
      d = d.trim().replace(/show more$/i, '');
      d = d.replace(/(\d)\.(\d)/g, '$1#####$2');
      d = d.replace(/\.([^ ])/g, '.\n$1');
      d = d.replace(/#####/g, '.')
      d = d.replace(/<br *\/?>/g, '\n');
      return d.split(/\n/g).map(line => {
        const bold = line.match(/<b>.*<\/b>/);
        return {
          text: line.replace(/<\/?b>/g, ''),
          bold
        };
      });
    }
  }
}
</script>
